import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class VendorRatingServices {
  // creating the vendor rating after grn
  createVendorRating = async (payload) => {
    const createdRating = await Helpers.post({
      url: Constants.CREATE_VENDOR_RATING,
      data: payload,
    });
    return createdRating;
  }

  updateVendorRating = async (payload) => {
    const updateRating = await Helpers.put({
      url: Constants.CREATE_VENDOR_RATING,
      data: payload,
    });
    return updateRating;
  }

  /**
     *
     * @param {*} payload
     * @return
     */
  // update vendor Rating for admin config
     updateVendorRatingSetting = async (payload) => {
       const vendorRating = await Helpers.put({
         url: Constants.UPDATE_VENDOR_RATING_CONFIG,
         data: payload,
       });
       return vendorRating;
     }

     /**
      *
      * @param {*} orgId
      * @return
      */
    getVendorRating = async (orgId) => {
      let url = `${Constants.GET_VENDOR_RATING_CONFIG}?`;
      if (orgId) url += `org_id=${orgId}`;
      const vendorRating = await Helpers.get({ url });
      return vendorRating;
    }

    enableVendorRatingConfig = async (payload) => {
      const createdRating = await Helpers.post({
        url: Constants.ENABLE_VENDOR_RATING_CONFIG,
        data: payload,
      });
      return createdRating;
    }
}
export default new VendorRatingServices();
